import React from 'react';
import { Stack, Typography } from '@mui/material';
import FormattedText from './FormattedText';
import useMessageStyles from '../../../hooks/useMessageStyles';

const REPLY_LABELS = {
  button_reply: 'Button reply',
  list_reply: 'List reply',
  quick_reply: 'Quick reply',
};

export default function ReplyMessage({ message }) {
  const { messageQuoteSx, messageTypeLabelSx } = useMessageStyles();
  const reply = message.reply || {};
  const label = REPLY_LABELS[reply.kind] || 'Reply';

  return (
    <Stack spacing={0.75}>
      <Typography component="span" sx={messageTypeLabelSx}>
        {label}
      </Typography>

      {reply.text && (
        <Typography variant="body2" sx={messageQuoteSx}>
          {reply.text}
        </Typography>
      )}

      <FormattedText text={message.text} />
    </Stack>
  );
}
